var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareFoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_486_22907",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 53
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 53,
    height: 53,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_486_22907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7003 42.9777C13.5367 42.9777 12.5493 42.5721 11.7382 41.761C10.9271 40.9498 10.5215 39.9625 10.5215 38.7989V16.6135C10.5215 15.801 10.8697 15.2397 11.5662 14.9297C12.2627 14.6196 12.8799 14.7336 13.4178 15.2716L16.6879 18.5416L14.9806 20.2488L16.0169 21.285L17.7241 19.5778L22.4465 24.3003L20.7393 26.0075L21.7755 27.0437L23.4827 25.3365L28.375 30.2288L26.6678 31.936L27.704 32.9722L29.4113 31.265L34.1337 35.9874L32.4265 37.6946L33.4627 38.7309L35.1699 37.0236L38.3126 40.1663C38.8222 40.6759 38.922 41.2719 38.612 41.9542C38.302 42.6365 37.7548 42.9777 36.9706 42.9777H14.7003ZM15.108 39.7501H32.0782L13.7491 21.4209V38.3912C13.7491 38.7875 13.8765 39.1131 14.1313 39.3679C14.3861 39.6227 14.7117 39.7501 15.108 39.7501Z",
    fill: "#FFBA69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareFoot);
export default __webpack_public_path__ + "static/media/square_foot.0d541e273ec9e18012b7898ca53a5969.svg";
export { ForwardRef as ReactComponent };